const AIVOICE_TTS_DEEPLINK = {
  VOICE_CLONING: 'tts://voice-cloning',
  LOGIN: 'tts://login',
};

const AIVOICE_TTS_APP_STORE_URL = 'https://itunes.apple.com/app/id6737223131';
const AIVOICE_TTS_GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.vbee.tts';

const DOWNLOAD_APP_LINK = 'https://app.vbee.vn';
const DOWNLOAD_APP_LINK_TEXT = 'App.vbee.vn';

export {
  AIVOICE_TTS_DEEPLINK,
  AIVOICE_TTS_APP_STORE_URL,
  AIVOICE_TTS_GOOGLE_PLAY_URL,
  DOWNLOAD_APP_LINK,
  DOWNLOAD_APP_LINK_TEXT,
};
